import React from "react";
import { motion } from "framer-motion";
import PropTypes from "prop-types";

export function LoadingSpinner() {
  return (
    <motion.div
      className="w-6 h-6 border-2 border-blue-500 rounded-full"
      animate={{ rotate: 360 }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: "linear",
      }}
    />
  );
}

LoadingSpinner.displayName = "LoadingSpinner";

LoadingSpinner.propTypes = {};

export { LoadingSpinner as _LoadingSpinner };
